function flattenMetadataSettings(settings) {
  if (typeof settings === "boolean")
    return {
      title: settings,
      description: settings,
      keywords: settings,
      socialImage: settings,
      canonicalUrl: settings,
      indexingBlocked: settings,
      favicon: settings
    };
  if (settings == null)
    return {};
  return settings;
}
export {
  flattenMetadataSettings
};
//# sourceMappingURL=page-seo-settings.js.map